/** @format */

export const PropertyTypes = {
  ForeignProperty: 'ForeignProperty',
  HousingCooperative: 'HousingCooperative',
  CommercialProperty: 'CommercialProperty',
  Cottage: 'Cottage',
  Plot: 'Plot',
  Condominium: 'Condominium',
  Farm: 'Farm',
  Project: 'Project',
  Premises: 'Premises',
  House: 'House'
};
